const ReturnRequests = () => import("./views/ReturnRequests.vue");

export default [
  {
    path: "/returnRequests",
    name: "returnRequests.list",
    component: ReturnRequests,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },
];
